import cn from 'classnames';
import React, { FC } from 'react';
import { SpecialOffers } from 'store/landing/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import SpecialOffer from './SpecialOffer';
import styles from './SpecialOffersGroup.module.scss';

export interface SpecialOffersGroupProps {
  heading?: string;
  subheading?: string;
  specialOffers?: SpecialOffers[];
}

const SpecialOffersGroup: FC<SpecialOffersGroupProps> = ({ heading, subheading, specialOffers }) => {
  const { theme } = useLandingPageContext();
  return (
    <div className={cn(styles.container, styles[`theme-${theme}`])}>
      {theme === 'studio' ? (
        <>
          {heading && <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html: heading || '' }} />}
          {subheading && <h2 className={styles.subheading} dangerouslySetInnerHTML={{ __html: subheading || '' }} />}
        </>
      ) : (
        <>
          {heading && <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html: heading || '' }} />}
          {subheading && <h2 className={styles.subheading} dangerouslySetInnerHTML={{ __html: subheading || '' }} />}
        </>
      )}

      {specialOffers && specialOffers.length > 0 && (
        <div
          className={cn(styles.specialOffersContainer, {
            [styles.centered]: specialOffers.length <= 2,
          })}
        >
          {specialOffers &&
            specialOffers.map((specialOffer) => (
              <SpecialOffer
                key={specialOffer.entryId}
                bannerImageUrlDesktop={specialOffer.bannerImageUrlDesktop}
                bannerImageUrl={specialOffer.bannerImageUrl}
                bannerImageUrlMobile={specialOffer.bannerImageUrlMobile}
                bannerImageUrlTablet={specialOffer.bannerImageUrlTablet}
                button={specialOffer.button}
                contentType={specialOffer.contentType}
                currentTargetDevice={specialOffer.currentTargetDevice}
                descriptionLines={specialOffer.descriptionLines}
                discount={specialOffer.discount}
                entryId={specialOffer.entryId}
                name={specialOffer.name}
                offerExpiration={specialOffer.offerExpiration}
                title={specialOffer.title}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default SpecialOffersGroup;
